module.exports = __webpack_public_path__ + "static/acupun_2-83c99badd6142351e2869d6ac960bb9a.png";